export default "__VITE_ASSET__BhBaQ4fA__"